module.exports = __webpack_public_path__ + "static/media/suit-2.d5ddfb28.jpg";